import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import DashRoutes from './MainRoutes';
import { LandingRoutes } from './MainRoutes';
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([LandingRoutes, DashRoutes, LoginRoutes]);
}
